<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" title="Guardar" type="button" (click)="saveProducto()" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <app-especie-eppo-popup (selected)="onAcceptDialogEspecieEppo($event)" [esExportacion]="true"></app-especie-eppo-popup>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Producto {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--DATOS BASICOS -->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosBasicos = !isCollapsedDatosBasicos" [attr.aria-expanded]="!isCollapsedDatosBasicos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos básicos
                                    <i *ngIf="isCollapsedDatosBasicos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosBasicos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosBasicos" [ngbCollapse]="isCollapsedDatosBasicos">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Grupo</label>
                                            <ng-select [items]="listGrupo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdGrupo"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listGrupo || listGrupo.length === 0"
                                                       [loading]="!listGrupo || listGrupo.length === 0"
                                                       notFoundText="Grupo no encontrado"
                                                       placeholder="-- Seleccione un Grupo --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdGrupo')"
                                                       (change)="onSelectGrupo()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGrupo','required')">
                                                Grupo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Forma</label>
                                            <ng-select [items]="listForma"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdForma"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listForma || listForma.length === 0"
                                                       [loading]="((!listForma || listForma.length === 0) && (form.value.IdGrupo > 0))"
                                                       notFoundText="Forma no encontrada"
                                                       placeholder="-- Seleccione una Forma --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdForma')"
                                                       (change)="onSelectForma()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdForma','required')">
                                                Forma es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="intEstado">País Origen</label>
                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPais"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPais || listPais.length === 0"
                                                       [loading]="!listPais || listPais.length === 0"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpDescripcion">Código Eppo</label>
                                            <div class="input-group">
                                                <input readonly formControlName="CodigoEppo" name="CodigoEppo" title="" class="form-control" id="" type="text" value="">
                                                <span class="input-group-btn">
                                                    &nbsp;<button [disabled]="!habilitarBusquedaEppo" name="btnSearchCodigoEppo" class="btn btn-list btn-secondary" type="button" title="Buscar Código Eppo" (click)="onSearchCodigoEppo()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>

                                            <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoEppo','required')">
                                                Código Eppo es obligatorio
                                            </div>-->
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nombre Botánico</label>
                                            <input readonly formControlName="NombreBotanico" [ngClass]="displayFieldCss('NombreBotanico')" name="NombreBotanico" title="" class="form-control" id="inpNRegistro" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreBotanico','required')">
                                                Nombre Botánico es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nombre Común</label>
                                            <input formControlName="NombreComun" name="NombreComun" [ngClass]="displayFieldCss('NombreComun')" maxlength="100" title="" class="form-control" id="inpNombre" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreComun','required')">
                                                Nombre Común es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="intEstado">Parcela</label>
                                            <ng-select [items]="listParcela"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdParcelaAtestFito"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listParcela || listParcela.length === 0"
                                                       [loading]="!listParcela || listParcela.length === 0"
                                                       notFoundText="Parcela no encontrada"
                                                       placeholder="-- Seleccione una Parcela --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorioPeso }" for="inpDescripcion">Peso Neto (Kg)</label>
                                            <input formControlName="Peso" [decimalsOnly]="3" name="Peso" [ngClass]="displayFieldCss('Peso')"
                                                   maxlength="15" title="" class="form-control" id="peso" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Peso','required')">
                                                Peso es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Peso','DecimalTopCero')">
                                                Peso debe ser mayor que cero
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorioVolumen }" for="inpDescripcion">Volumen (m³)</label>
                                            <input formControlName="Volumen" [decimalsOnly]="3" name="Volumen" [ngClass]="displayFieldCss('Volumen')" maxlength="15" title="" class="form-control" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Volumen','required')">
                                                Volumen es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Volumen','DecimalTopCero')">
                                                Volumen debe ser mayor que cero
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorioUnidades }" for="inpDescripcion">Unidades</label>
                                            <input formControlName="Unidades" numbersOnly name="Unidades" [ngClass]="displayFieldCss('Unidades')" maxlength="10" title="" class="form-control" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Unidades','required')">
                                                Unidades es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Unidades','DecimalTopCero')">
                                                Unidades debe ser mayor que cero
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
